import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';

/**
 * 表单输入框组件 - 受控组件
 */
const FormInput = ({
    label,
    error,
    multiline,
    rows,
    maxLength,
    placeholder,
    value = '',
    type,
    onChange,
    ...restProps
}) => {
    const inputClass = `${styles.input} ${error ? styles.inputError : ''}`;
    const charCount = value?.length ?? 0;

    const commonProps = {
        placeholder,
        value,
        onChange,
        maxLength,
    };

    if (multiline) {
        return (
            <div className={styles.field}>
                {label && maxLength && (
                    <div className={styles.labelRow}>
                        <label className={styles.label}>{label}</label>
                        <span className={styles.charCount}>
                            {charCount}/{maxLength}
                        </span>
                    </div>
                )}
                {label && !maxLength && <label className={styles.label}>{label}</label>}
                <textarea
                    {...commonProps}
                    className={`${inputClass} ${styles.textarea}`}
                    rows={rows}
                    {...restProps}
                />
                {error && <span className={styles.errorText}>{error}</span>}
            </div>
        );
    }

    return (
        <div className={styles.field}>
            {label && <label className={styles.label}>{label}</label>}
            <input
                {...commonProps}
                type={type}
                className={inputClass}
                {...restProps}
            />
            {error && <span className={styles.errorText}>{error}</span>}
        </div>
    );
};

FormInput.displayName = 'FormInput';

FormInput.propTypes = {
    label: PropTypes.string,
    error: PropTypes.string,
    multiline: PropTypes.bool,
    rows: PropTypes.number,
    maxLength: PropTypes.number,
    placeholder: PropTypes.string,
    value: PropTypes.string,
    type: PropTypes.string,
    onChange: PropTypes.func.isRequired,
};

FormInput.defaultProps = {
    multiline: false,
    rows: 4,
};

export default FormInput;
